import { render, staticRenderFns } from "./video-controls.vue?vue&type=template&id=bca9a144&"
import script from "./video-controls.vue?vue&type=script&lang=js&"
export * from "./video-controls.vue?vue&type=script&lang=js&"
import style0 from "./video-controls.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VIcon,VSlider})
